/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/cloud'
export default icon
